/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull browser_sdk'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 11
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/young-living/Development/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/young-living/Development/implementation/browser_sdk)
 */

import * as amplitude from '@amplitude/analytics-browser';

export type Environment = 'development';

export const ApiKey: Record<Environment, string> = {
  development: '932314fe7ce505c7b0b7941c0f074927'
};

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration: BrowserOptions = {
  plan: {
    version: '11',
    branch: 'main',
    source: 'browser_sdk',
    versionId: 'a0b2820c-550c-46ad-afb2-9b3d4f3c61ed'
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-typescript-ampli',
      sourceVersion: '2.0.0'
    }
  }
};

export interface LoadOptionsBase { disabled?: boolean }

export type LoadOptionsWithEnvironment = LoadOptionsBase & { environment: Environment; client?: { configuration?: BrowserOptions; }; };
export type LoadOptionsWithApiKey = LoadOptionsBase & { client: { apiKey: string; configuration?: BrowserOptions; } };
export type LoadOptionsWithClientInstance = LoadOptionsBase & { client: { instance: BrowserClient; } };

export type LoadOptions = LoadOptionsWithEnvironment | LoadOptionsWithApiKey | LoadOptionsWithClientInstance;

export interface IdentifyProperties {
  /**
   * **ID to track test groups and special targeted segments. This should line up to value provided in Snowflake table. (need to insert table name later)**
   */
  OPID?: string;
}

export interface ClickProperties {
  /**
   * Location of the CLICK\_*NAME. For example, ADD_TO\_*CART can have a CLICK\_*LOCATION of QUICK\_*SEARCH or PRODUCT\_*CATEGORY\_*PAGE. See this doc for details: [CLICK_NAME & CLICK_LOCATION Screenshots.docx](https://younglivingeo-my.sharepoint.com/:w:/g/personal/cstevens_youngliving_com/EbtJBMuZDlhHgdpYEF0MG98BUHE7ZUZT6YsBOg3xB2UAIQ?e=59B1Ez)
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | QUICK_SEARCH, PRODUCT_CATEGORY_PAGE, CAROUSEL_MOST_POPULAR_PRODUCTS, CAROUSEL_SOURCED_FROM_THIS_FARM, CAROUSEL_YOU_MAY_ALSO_LIKE, CART_SIDEBAR, CART_PAGE, CHECKOUT_PAGE, TOP_NAV_BAR, AUTH_PAGE, PRODUCT_CATEGORY_DROPDOWN, PRODUCT_CATEGORY_LIST, CAROUSEL_FREQUENTLY_PURCHASED_WITH, PRODUCT_DETAIL_PAGE, LOYALTY_TEMPLATE |
   */
  CLICK_LOCATION:
    | "QUICK_SEARCH"
    | "PRODUCT_CATEGORY_PAGE"
    | "CAROUSEL_MOST_POPULAR_PRODUCTS"
    | "CAROUSEL_SOURCED_FROM_THIS_FARM"
    | "CAROUSEL_YOU_MAY_ALSO_LIKE"
    | "CART_SIDEBAR"
    | "CART_PAGE"
    | "CHECKOUT_PAGE"
    | "TOP_NAV_BAR"
    | "AUTH_PAGE"
    | "PRODUCT_CATEGORY_DROPDOWN"
    | "PRODUCT_CATEGORY_LIST"
    | "CAROUSEL_FREQUENTLY_PURCHASED_WITH"
    | "PRODUCT_DETAIL_PAGE"
    | "LOYALTY_TEMPLATE";
  /**
   * Grouping of click location. Some CLICK_NAMEs will have multiple CLICK_LOCATIONs (ie ADD_TO_CART).
   *
   * Screenshots of where each click lives:
   *
   * [CLICK_NAME & CLICK_LOCATION Screenshots.docx](https://younglivingeo-my.sharepoint.com/:w:/g/personal/cstevens_youngliving_com/EbtJBMuZDlhHgdpYEF0MG98BUHE7ZUZT6YsBOg3xB2UAIQ?e=59B1Ez)
   *
   *
   * !\[\](file:///C:/Users/cstevens/AppData/Local/Temp/msohtmlclip1/01/clip_image044.png)
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | ADD_TO_CART, ADD_TO_LOYALTY, PROMO, PRODUCT_LIST, FILTER_COMPLETE, FILTER_START, SORT, CONTINUE_SHOPPING, CHECKOUT_START, CHECKOUT_COMPLETE, QUANTITY_DELETE, CREATE_ACCOUNT_START, CREATE_ACCOUNT_COMPLETE, LOGIN_START, LOGIN_COMPLETE, ADD_TO_WISHLIST, CHECKOUT_CONTACT, CHECKOUT_SPONSOR, CHECKOUT_SHIPPING, CHECKOUT_PAYMENT_GENERAL, CHECKOUT_PAYMENT_VENMO, CHECKOUT_PAYMENT_PAYPAL, CHECKOUT_PAYMENT_PAYPAL_CREDIT, PAYPAL_BUY_NOW, VIEW_CART, VIEW_ALL, QUANTITY_DELETE_ALL, SAVE_PAYMENT, SAVE_TEMPLATE, REMIND_ME_LATER, ADD_BACKUP, DONT_SHOW |
   */
  CLICK_NAME:
    | "ADD_TO_CART"
    | "ADD_TO_LOYALTY"
    | "PROMO"
    | "PRODUCT_LIST"
    | "FILTER_COMPLETE"
    | "FILTER_START"
    | "SORT"
    | "CONTINUE_SHOPPING"
    | "CHECKOUT_START"
    | "CHECKOUT_COMPLETE"
    | "QUANTITY_DELETE"
    | "CREATE_ACCOUNT_START"
    | "CREATE_ACCOUNT_COMPLETE"
    | "LOGIN_START"
    | "LOGIN_COMPLETE"
    | "ADD_TO_WISHLIST"
    | "CHECKOUT_CONTACT"
    | "CHECKOUT_SPONSOR"
    | "CHECKOUT_SHIPPING"
    | "CHECKOUT_PAYMENT_GENERAL"
    | "CHECKOUT_PAYMENT_VENMO"
    | "CHECKOUT_PAYMENT_PAYPAL"
    | "CHECKOUT_PAYMENT_PAYPAL_CREDIT"
    | "PAYPAL_BUY_NOW"
    | "VIEW_CART"
    | "VIEW_ALL"
    | "QUANTITY_DELETE_ALL"
    | "SAVE_PAYMENT"
    | "SAVE_TEMPLATE"
    | "REMIND_ME_LATER"
    | "ADD_BACKUP"
    | "DONT_SHOW";
  /**
   * Specific to code entered at checkout. Sitewide/specific product sales will be seen in PROMO.
   */
  COUPON_CODE?: string;
  /**
   * 3-letter currency code. Will keep as a string for now since there are 156 different values.
   */
  CURRENCY_CODE?: string;
  /**
   * Identifies the customer/member that placed the order. This is not to be confused with the user ID used by Amplitude. This ID should match to what is used in the data warehouse.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  CUST_ID?: number;
  /**
   * Last date of purchase including one-time, process now and/or loyalty.
   */
  CUSTOMER_STATUS?: string;
  /**
   * ??
   */
  HAS_RESTRICTIONS?: boolean;
  /**
   * Product added was currently in the wishlist.
   */
  IN_WISHLIST?: boolean;
  /**
   * Which list or carousel was the product added from?
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | QUICK_SEARCH_RESULTS, HOME_PAGE_POPULAR_PRODUCTS, PRODUCT_CATEGORY_PAGE, PRODUCT_DETAIL_YOU_MAY_ALSO_LIKE |
   */
  LIST_NAME?:
    | "QUICK_SEARCH_RESULTS"
    | "HOME_PAGE_POPULAR_PRODUCTS"
    | "PRODUCT_CATEGORY_PAGE"
    | "PRODUCT_DETAIL_YOU_MAY_ALSO_LIKE";
  /**
   * Where on the list was the product featured? Coincides with LIST_NAME. Start at 1.
   *
   * Home page 'most popular products', PDP 'you may also like', quick search and product category page all contain this feature.
   *
   * *Idea: Number corresponding to position depends on the feature.*
   *
   * **Home page 'most populat products' and PDP 'you may also like'**: Each view ("dot") correponds to a list position.
   *
   * **Product category page**: Each row and page correpond to a number. There are currently 6 rows to a page. A product listed in row 1, page 1 = LIST_POSITION 1. A product listed in row 6 of page 2 = LIST_POSITION 12.
   *
   * Quick search:
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   */
  LIST_POSITION?: number;
  /**
   * logged out means that amplitude id has logged in in the past
   *
   *
   *
   * no account would mean either there isn't an account associated with that id or they haven't logged in yet.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | LOGGED_IN, LOGGED_OUT |
   */
  LOGGED_IN_STATE: "LOGGED_IN" | "LOGGED_OUT";
  /**
   * Identifies the order and should match order ID in the data warehouse. This is the BSI/Legacy order ID.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  ORDER_ID?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | ONE_TIME, AUTOSHIP |
   */
  ORDER_SOURCE?: "ONE_TIME" | "AUTOSHIP";
  PAGE_PATH: string;
  PAGE_QUERY_STRING?: string;
  PAGE_TITLE: string;
  PAGE_URL: string;
  /**
   * Product SKU. If this contains a letter, it will indicate a discount.
   */
  PART_NUMBER?: string;
  /**
   * Product SKU removing any letters that indicate discount. This would show product SKU version that is full price.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  PART_NUMBER_MINUS_ALPHA?: number;
  /**
   * Payment type of purchase (Amex, Visa, ACH, etc.)
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | American Express, Visa, ACH, Mastercard |
   */
  PAYMENT_METHOD?: "American Express" | "Visa" | "ACH" | "Mastercard";
  /**
   * Did the user purchase using Paypal quickpay option (not to be confused with using Paypal in regular checkout).
   */
  PAYPAL_BUY_NOW?: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | object |
   */
  PRODUCT_ARRAY?: {
    /**
     * To be used by the product array when one or multiple products' information is needed. For a given product in the array, flag whether this product has any restrictions.
     */
    HAS_RESTRICTIONS?: boolean;
    /**
     * To be used by the product array when one or multiple products' information is needed. For a given product in an array, flag whether the item was in the wishlist at the time of being called in the array.
     */
    IN_WISHLIST?: boolean;
    /**
     * To be used by the product array when one or multiple products' information is needed.
     */
    IS_RECOMMENDED_PRODUCT?: string;
    /**
     * To be used by the product array when one or multiple products' information is needed. For a given product in the array, this identifies the location of a list name. This is a subset of LIST_NAME. Use this when you have multiple carousels (for instance) that you need to identify.
     */
    LIST_LOCATION?: {
      [k: string]: any;
    };
    /**
     * To be used by the product array when one or multiple products' information is needed. For a given product in the array, what was the location that the product was added from? Including PDP and adding from quick search. \*\* May need to consider changing this property name to make it less confusing.
     */
    LIST_NAME?: "QUICK_SEARCH" | "PRODUCT_CAROUSEL" | "PRODUCT_CATEGORY_PAGE";
    /**
     * To be used by the product array when one or multiple products' information is needed. Given a product in the array, this identifies where on a list a product was added from. \*\* We need to design out how we'd like this to look?
     */
    LIST_POSITION?: number;
    /**
     * **To be used by the product array when one or multiple products' information is needed. For a given product in the array, this identifies whether or not the product was purchased with loyalty points during the checkout process.**
     */
    LOYALTY_POINTS_USED?: boolean;
    ORDER_SOURCE?: "AUTOSHIP" | "ONE_TIME";
    /**
     * To be used by the product array when multiple products' information is needed. This indicates SKU, which can include a letter for discounted SKUs.
     */
    PART_NUMBER?: string;
    /**
     * To be used by the product array when multiple products' information is needed. This is the SKU version without the letter indicating a discount. This will always be the full-price version of the SKU.
     */
    PART_NUMBER_MINUS_ALPHA?: number;
    /**
     * To be used by the product array when one or multiple products' information is needed. This should be reflected as the sale price, if the sale price exists at the moment of checkout. If there is not a price, keep this as null. \*\* Would this be better as a flag??
     */
    PRICE_ON_SALE?: number;
    /**
     * To be used by the product array when one or multiple products' information is needed. Retail price of a given product in the array. Only populate when retail price is given. (get feedback here from the group)
     */
    PRICE_RETAIL?: number;
    /**
     * To be used by the product array when one or multiple products' information is needed. This will be the wholesale price of a given product in the array. Only populate when the wholesale price is given.
     */
    PRICE_WHOLESALE?: number;
    /**
     * Will be used as part of the array when multiple products' information needs to be seen.
     */
    PRODUCT_NAME?: string;
    /**
     * To be used by the product array when multiple products' information is needed. This will show PV of a given product in the array.
     */
    PV?: number;
    /**
     * To be used by the product array when multiple products' information is needed. Quantity of given product in the array.
     */
    QUANTITY?: number;
    /**
     * To be used by the product array when one or multiple products' information is needed. For a given product in the array, identify the stock status when array was passed. Note: out of stock should not be a flag since a product won't be added or purchase if out of stock.
     */
    STOCK_STATUS?: "LOW_STOCK" | "IN_STOCK";
    /**
     * To be used by the product array when multiple products' information is needed. This will show the subtotal price of a given product in the array. If there is a wholesale or discounted price, it will be reflected in this number.
     */
    UNIT_PRICE?: number;
  }[];
  PRODUCT_NAME?: string;
  /**
   * Subtotal - total amount due before taxes and shipping.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  PRODUCT_SALES_AMOUNT_TOTAL?: number;
  /**
   * Indicates there was a sale on a product. Not to be confused with discounted products via PART_NUMBER or COUPON_CODE. Mark null if no promo existed.
   */
  PROMO_EVENT?: string;
  /**
   * PV of specific product.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  PV_AMOUNT?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  PV_TOTAL?: number;
  /**
   * Quantity of product added in a given click (on add to carts).
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  QUANTITY?: number;
  /**
   * In the sort function, return what was selected.
   */
  SELECTED_SORT?: string;
  /**
   * Indicates status of inventory when clicking add to cart. Note: 'out of stock' should not exist since it won't be possible to add to cart if item was out of stock.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | IN_STOCK, LOW_STOCK |
   */
  STOCK_STATUS?: "IN_STOCK" | "LOW_STOCK";
  TIME_STAMP_LOCAL?: string;
  /**
   * Subtotal price of product (before shipping and taxes). This should reflect any discounts, wholesale price. But not the price after applying COUPON_CODE.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  UNIT_PRICE?: number;
}

export interface DlvDownlineMemberProperties {
  /**
   * The Action taken by the user by interacting with an Element which generates the event.
   */
  ACTION: string;
  /**
   * The type of Action  which is a group to help facilitate aggregating for analytics (Saving Data, Download Data, Loading Data, View Changes)
   */
  ACTION_TYPE: string;
  /**
   * The Data Type that extends the required DLV data to provide additional insight into the context of the action generating the event.
   */
  EVENT_DATA: string;
  /**
   * Unique ID representing the Account ID plus a timestanp. Useful when 1 action generates multiple events for grouping these types of events.
   */
  EVENT_ID: string;
  /**
   * The general area of the application where these events are being sent from, such as the DLV.
   */
  EVENT_TYPE: string;
  /**
   * Validation Errors encounted when processing the data to send in the event.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  EVENT_VALIDATION_ERRORS: string[];
  /**
   * The Tab where the result of an Action changed to if a View Change occurred
   */
  TO_TAB?: string;
  /**
   * The View where the result of an Action changed to if a View Change occurred
   */
  TO_VIEW?: string;
  /**
   * How the user interacted with the Element that generated the Event (Mouse, Keyboard, Shortcut)
   */
  TRIGGER_ACTION: string;
  /**
   * The name of the Element that generated the Event
   */
  TRIGGER_ELEMENT: string;
  /**
   * Optional category that can be assigned to a group of Elements capable of triggering events to help facilite aggregating for analytics
   */
  TRIGGER_GROUP?: string;
  /**
   * Optional Tab when the Element triggering the Event is on a View with Tabs.
   */
  TRIGGER_TAB?: string;
  /**
   * The View where the Element is that triggered an Event
   */
  TRIGGER_VIEW: string;
  /**
   * Account ID of the logged in member generating the event.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   */
  USER_ACCOUNT_ID: number;
  USER_ACHIEVED_RANK: string;
  USER_AFFILIATION: string;
  USER_PAID_RANK: string;
  /**
   * Account ID of the Downline Member
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  VIEWING_ACCOUNT_ID: number;
  /**
   * Activation Date of the Downline Member
   */
  VIEWING_ACTIVATION_DATE?: string;
  /**
   * Autoship Active of the Downline Member
   */
  VIEWING_AUTOSHIP_ACTIVE?: boolean;
  /**
   * Autoship Day of the Month of the Downline Member
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  VIEWING_AUTOSHIP_DAY?: number;
  /**
   * Autoship Shipped of the Downline Member
   */
  VIEWING_AUTOSHIP_SHIPPED?: boolean;
  /**
   * Autoship Status of the Downline Member
   */
  VIEWING_AUTOSHIP_STATUS?: string;
  /**
   * Commission Qualified of the Downline Member
   */
  VIEWING_COMMISSION_QUALIFIED?: boolean;
  /**
   * Customer Type of the Downline Member
   */
  VIEWING_CUSTOMER_TYPE?: string;
  /**
   * Last Order Date of the Downline Member
   */
  VIEWING_LAST_ORDER_DATE?: string;
  /**
   * Max Rank of the Downline Member
   */
  VIEWING_MAX_RANK?: string;
  /**
   * Months Inactive of the Downline Member
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  VIEWING_MONTHS_INACTIVE?: number;
  /**
   * Months Without Order of the Downline Member
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  VIEWING_MONTHS_WITHOUT_ORDER?: number;
  /**
   * OGV of the Downline Member
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  VIEWING_OGV?: number;
  /**
   * Rank of the Downline Member
   */
  VIEWING_RANK?: string;
  /**
   * Signup Date of the Downline Member
   */
  VIEWING_SIGNUP_DATE?: string;
  /**
   * Total PV of the Downline Member
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  VIEWING_TOTAL_PV?: number;
}

export interface DlvFilterDownloadedProperties {
  /**
   * The Action taken by the user by interacting with an Element which generates the event.
   */
  ACTION: string;
  /**
   * The type of Action  which is a group to help facilitate aggregating for analytics (Saving Data, Download Data, Loading Data, View Changes)
   */
  ACTION_TYPE: string;
  /**
   * Added Columns in addition to the Select All States of Default and None
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  DOWNLOAD_ADDED_COLUMNS: string[];
  /**
   * The Default Columns presented to the user when first presented with the list of options.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  DOWNLOAD_DEFAULT_COLUMNS: string[];
  /**
   * Removed Columns from the Select All States of Default and All
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  DOWNLOAD_REMOVED_COLUMNS: string[];
  /**
   * The State of the Select All checkbox when the Download was initiated (Default, All, None)
   */
  DOWNLOAD_SELECT_ALL: string;
  /**
   * Final Columns selected by the user for Download
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  DOWNLOAD_SUBMITTED_COLUMNS: string[];
  /**
   * The Data Type that extends the required DLV data to provide additional insight into the context of the action generating the event.
   */
  EVENT_DATA: string;
  /**
   * Unique ID representing the Account ID plus a timestanp. Useful when 1 action generates multiple events for grouping these types of events.
   */
  EVENT_ID: string;
  /**
   * The general area of the application where these events are being sent from, such as the DLV.
   */
  EVENT_TYPE: string;
  /**
   * Validation Errors encounted when processing the data to send in the event.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  EVENT_VALIDATION_ERRORS: string[];
  /**
   * The Standard Report used as the Base Report when a user creates a custom report in the DLV
   */
  REPORT_BASE?: string;
  /**
   * The current number of Rows Displayed as a result of a Report Execution
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  REPORT_DISPLAY_ROWS?: number;
  /**
   * The name of the Column in which a Filter will be applied
   */
  REPORT_FILTER_COLUMN: string;
  /**
   * The name of the Operator in which a Filter will be applied
   */
  REPORT_FILTER_OPERATOR: string;
  /**
   * A Range of Filter Values when applicable
   */
  REPORT_FILTER_TIER?: string;
  /**
   * Indicates if the Filter being applied is part of a Saved Report or is an Adhoc Filter applied to a report
   */
  REPORT_FILTER_TYPE: string;
  /**
   * The entered Value in which a Filter will be applied
   */
  REPORT_FILTER_VALUE: string;
  /**
   * The name of the Report in the DLV if a Standard Report and 'User Defined' if a custom Report
   */
  REPORT_NAME: string;
  /**
   * Details pertaining to the Period the user is interacting with when historical data is made available to the User
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Max Value | 0 |
   */
  REPORT_PERIOD_LAG?: number;
  /**
   * The Field or Column to used when a Sort is applied to data
   */
  REPORT_SORT_BY?: string;
  /**
   * The direction choosen when a Sort is applied
   */
  REPORT_SORT_ORDER?: string;
  /**
   * The total number of Children returned as a result of a Report Execution
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  REPORT_TOTAL_CHILDREN?: number;
  /**
   * The total number of Rows Returned as a result of a Report Execution
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  REPORT_TOTAL_ROWS?: number;
  /**
   * Indicates if a Report is a Standard or User Defined Report
   */
  REPORT_TYPE: string;
  /**
   * The Tab where the result of an Action changed to if a View Change occurred
   */
  TO_TAB?: string;
  /**
   * The View where the result of an Action changed to if a View Change occurred
   */
  TO_VIEW?: string;
  /**
   * How the user interacted with the Element that generated the Event (Mouse, Keyboard, Shortcut)
   */
  TRIGGER_ACTION: string;
  /**
   * The name of the Element that generated the Event
   */
  TRIGGER_ELEMENT: string;
  /**
   * Optional category that can be assigned to a group of Elements capable of triggering events to help facilite aggregating for analytics
   */
  TRIGGER_GROUP?: string;
  /**
   * Optional Tab when the Element triggering the Event is on a View with Tabs.
   */
  TRIGGER_TAB?: string;
  /**
   * The View where the Element is that triggered an Event
   */
  TRIGGER_VIEW: string;
  /**
   * Account ID of the logged in member generating the event.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   */
  USER_ACCOUNT_ID: number;
  USER_ACHIEVED_RANK: string;
  USER_AFFILIATION: string;
  USER_PAID_RANK: string;
}

export interface DlvFilterExecutedProperties {
  /**
   * The Action taken by the user by interacting with an Element which generates the event.
   */
  ACTION: string;
  /**
   * The type of Action  which is a group to help facilitate aggregating for analytics (Saving Data, Download Data, Loading Data, View Changes)
   */
  ACTION_TYPE: string;
  /**
   * The Data Type that extends the required DLV data to provide additional insight into the context of the action generating the event.
   */
  EVENT_DATA: string;
  /**
   * Unique ID representing the Account ID plus a timestanp. Useful when 1 action generates multiple events for grouping these types of events.
   */
  EVENT_ID: string;
  /**
   * The general area of the application where these events are being sent from, such as the DLV.
   */
  EVENT_TYPE: string;
  /**
   * Validation Errors encounted when processing the data to send in the event.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  EVENT_VALIDATION_ERRORS: string[];
  /**
   * The Standard Report used as the Base Report when a user creates a custom report in the DLV
   */
  REPORT_BASE?: string;
  /**
   * The current number of Rows Displayed as a result of a Report Execution
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  REPORT_DISPLAY_ROWS?: number;
  /**
   * The name of the Column in which a Filter will be applied
   */
  REPORT_FILTER_COLUMN: string;
  /**
   * The name of the Operator in which a Filter will be applied
   */
  REPORT_FILTER_OPERATOR: string;
  /**
   * A Range of Filter Values when applicable
   */
  REPORT_FILTER_TIER?: string;
  /**
   * Indicates if the Filter being applied is part of a Saved Report or is an Adhoc Filter applied to a report
   */
  REPORT_FILTER_TYPE: string;
  /**
   * The entered Value in which a Filter will be applied
   */
  REPORT_FILTER_VALUE: string;
  /**
   * The name of the Report in the DLV if a Standard Report and 'User Defined' if a custom Report
   */
  REPORT_NAME: string;
  /**
   * Details pertaining to the Period the user is interacting with when historical data is made available to the User
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Max Value | 0 |
   */
  REPORT_PERIOD_LAG?: number;
  /**
   * The Field or Column to used when a Sort is applied to data
   */
  REPORT_SORT_BY?: string;
  /**
   * The direction choosen when a Sort is applied
   */
  REPORT_SORT_ORDER?: string;
  /**
   * The total number of Children returned as a result of a Report Execution
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  REPORT_TOTAL_CHILDREN?: number;
  /**
   * The total number of Rows Returned as a result of a Report Execution
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  REPORT_TOTAL_ROWS?: number;
  /**
   * Indicates if a Report is a Standard or User Defined Report
   */
  REPORT_TYPE: string;
  /**
   * The Tab where the result of an Action changed to if a View Change occurred
   */
  TO_TAB?: string;
  /**
   * The View where the result of an Action changed to if a View Change occurred
   */
  TO_VIEW?: string;
  /**
   * How the user interacted with the Element that generated the Event (Mouse, Keyboard, Shortcut)
   */
  TRIGGER_ACTION: string;
  /**
   * The name of the Element that generated the Event
   */
  TRIGGER_ELEMENT: string;
  /**
   * Optional category that can be assigned to a group of Elements capable of triggering events to help facilite aggregating for analytics
   */
  TRIGGER_GROUP?: string;
  /**
   * Optional Tab when the Element triggering the Event is on a View with Tabs.
   */
  TRIGGER_TAB?: string;
  /**
   * The View where the Element is that triggered an Event
   */
  TRIGGER_VIEW: string;
  /**
   * Account ID of the logged in member generating the event.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   */
  USER_ACCOUNT_ID: number;
  USER_ACHIEVED_RANK: string;
  USER_AFFILIATION: string;
  USER_PAID_RANK: string;
}

export interface DlvFilterSavedProperties {
  /**
   * The Action taken by the user by interacting with an Element which generates the event.
   */
  ACTION: string;
  /**
   * The type of Action  which is a group to help facilitate aggregating for analytics (Saving Data, Download Data, Loading Data, View Changes)
   */
  ACTION_TYPE: string;
  /**
   * The Data Type that extends the required DLV data to provide additional insight into the context of the action generating the event.
   */
  EVENT_DATA: string;
  /**
   * Unique ID representing the Account ID plus a timestanp. Useful when 1 action generates multiple events for grouping these types of events.
   */
  EVENT_ID: string;
  /**
   * The general area of the application where these events are being sent from, such as the DLV.
   */
  EVENT_TYPE: string;
  /**
   * Validation Errors encounted when processing the data to send in the event.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  EVENT_VALIDATION_ERRORS: string[];
  /**
   * The Standard Report used as the Base Report when a user creates a custom report in the DLV
   */
  REPORT_BASE?: string;
  /**
   * The name of the Column in which a Filter will be applied
   */
  REPORT_FILTER_COLUMN: string;
  /**
   * The name of the Operator in which a Filter will be applied
   */
  REPORT_FILTER_OPERATOR: string;
  /**
   * A Range of Filter Values when applicable
   */
  REPORT_FILTER_TIER?: string;
  /**
   * Indicates if the Filter being applied is part of a Saved Report or is an Adhoc Filter applied to a report
   */
  REPORT_FILTER_TYPE: string;
  /**
   * The entered Value in which a Filter will be applied
   */
  REPORT_FILTER_VALUE: string;
  /**
   * The name of the Report in the DLV if a Standard Report and 'User Defined' if a custom Report
   */
  REPORT_NAME: string;
  /**
   * Indicates if a Report is a Standard or User Defined Report
   */
  REPORT_TYPE: string;
  /**
   * The Cadence in which a Scheduled Report should be Executed
   */
  SCHEDULE_CADENCE: string;
  /**
   * The Days of the Month in which a Scheduled Report should be Executed
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | number |
   */
  SCHEDULE_DAYS_OF_MONTH?: number[];
  /**
   * The Days of the Week in which a Scheduled Report should be Executed
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  SCHEDULE_DAYS_OF_WEEK?: string[];
  /**
   * The Period Lag to apply when a Scheduled Report should be Executed
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   * | Max Value | 0 |
   */
  SCHEDULE_PERIOD_LAG?: number;
  /**
   * The Time of Day in which a Scheduled Report should be Executed
   */
  SCHEDULE_TIME_OF_DAY?: string;
  /**
   * The Tab where the result of an Action changed to if a View Change occurred
   */
  TO_TAB?: string;
  /**
   * The View where the result of an Action changed to if a View Change occurred
   */
  TO_VIEW?: string;
  /**
   * How the user interacted with the Element that generated the Event (Mouse, Keyboard, Shortcut)
   */
  TRIGGER_ACTION: string;
  /**
   * The name of the Element that generated the Event
   */
  TRIGGER_ELEMENT: string;
  /**
   * Optional category that can be assigned to a group of Elements capable of triggering events to help facilite aggregating for analytics
   */
  TRIGGER_GROUP?: string;
  /**
   * Optional Tab when the Element triggering the Event is on a View with Tabs.
   */
  TRIGGER_TAB?: string;
  /**
   * The View where the Element is that triggered an Event
   */
  TRIGGER_VIEW: string;
  /**
   * Account ID of the logged in member generating the event.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   */
  USER_ACCOUNT_ID: number;
  USER_ACHIEVED_RANK: string;
  USER_AFFILIATION: string;
  USER_PAID_RANK: string;
}

export interface DlvReportDownloadedProperties {
  /**
   * The Action taken by the user by interacting with an Element which generates the event.
   */
  ACTION: string;
  /**
   * The type of Action  which is a group to help facilitate aggregating for analytics (Saving Data, Download Data, Loading Data, View Changes)
   */
  ACTION_TYPE: string;
  /**
   * Added Columns in addition to the Select All States of Default and None
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  DOWNLOAD_ADDED_COLUMNS: string[];
  /**
   * The Default Columns presented to the user when first presented with the list of options.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  DOWNLOAD_DEFAULT_COLUMNS: string[];
  /**
   * Removed Columns from the Select All States of Default and All
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  DOWNLOAD_REMOVED_COLUMNS: string[];
  /**
   * The State of the Select All checkbox when the Download was initiated (Default, All, None)
   */
  DOWNLOAD_SELECT_ALL: string;
  /**
   * Final Columns selected by the user for Download
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  DOWNLOAD_SUBMITTED_COLUMNS: string[];
  /**
   * The Data Type that extends the required DLV data to provide additional insight into the context of the action generating the event.
   */
  EVENT_DATA: string;
  /**
   * Unique ID representing the Account ID plus a timestanp. Useful when 1 action generates multiple events for grouping these types of events.
   */
  EVENT_ID: string;
  /**
   * The general area of the application where these events are being sent from, such as the DLV.
   */
  EVENT_TYPE: string;
  /**
   * Validation Errors encounted when processing the data to send in the event.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  EVENT_VALIDATION_ERRORS: string[];
  /**
   * The Count of Adhoc Filters applied when a Report is Executed
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  REPORT_ADHOC_FILTER_COUNT?: number;
  /**
   * The Adhoc Filters applied when a Report is Executed
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  REPORT_ADHOC_FILTERS?: string[];
  /**
   * All the Filters applied when a Report is Executed
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  REPORT_ALL_FILTERS?: string[];
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  REPORT_ALL_FILTERS_COUNT?: number;
  /**
   * The Standard Report used as the Base Report when a user creates a custom report in the DLV
   */
  REPORT_BASE?: string;
  /**
   * The current number of Rows Displayed as a result of a Report Execution
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  REPORT_DISPLAY_ROWS?: number;
  /**
   * The name of the Report in the DLV if a Standard Report and 'User Defined' if a custom Report
   */
  REPORT_NAME: string;
  /**
   * Details pertaining to the Period the user is interacting with when historical data is made available to the User
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Max Value | 0 |
   */
  REPORT_PERIOD_LAG?: number;
  /**
   * The Count of Report or Saved Filters applied when a Report is Executed
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  REPORT_SAVED_FILTER_COUNT?: number;
  /**
   * The Saved Filters applied when a Report is Executed
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  REPORT_SAVED_FILTERS?: string[];
  /**
   * The Field or Column to used when a Sort is applied to data
   */
  REPORT_SORT_BY?: string;
  /**
   * The direction choosen when a Sort is applied
   */
  REPORT_SORT_ORDER?: string;
  /**
   * The total number of Children returned as a result of a Report Execution
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  REPORT_TOTAL_CHILDREN?: number;
  /**
   * The total number of Rows Returned as a result of a Report Execution
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  REPORT_TOTAL_ROWS?: number;
  /**
   * Indicates if a Report is a Standard or User Defined Report
   */
  REPORT_TYPE: string;
  /**
   * The Tab where the result of an Action changed to if a View Change occurred
   */
  TO_TAB?: string;
  /**
   * The View where the result of an Action changed to if a View Change occurred
   */
  TO_VIEW?: string;
  /**
   * How the user interacted with the Element that generated the Event (Mouse, Keyboard, Shortcut)
   */
  TRIGGER_ACTION: string;
  /**
   * The name of the Element that generated the Event
   */
  TRIGGER_ELEMENT: string;
  /**
   * Optional category that can be assigned to a group of Elements capable of triggering events to help facilite aggregating for analytics
   */
  TRIGGER_GROUP?: string;
  /**
   * Optional Tab when the Element triggering the Event is on a View with Tabs.
   */
  TRIGGER_TAB?: string;
  /**
   * The View where the Element is that triggered an Event
   */
  TRIGGER_VIEW: string;
  /**
   * Account ID of the logged in member generating the event.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   */
  USER_ACCOUNT_ID: number;
  USER_ACHIEVED_RANK: string;
  USER_AFFILIATION: string;
  USER_PAID_RANK: string;
}

export interface DlvReportExecutedProperties {
  /**
   * The Action taken by the user by interacting with an Element which generates the event.
   */
  ACTION: string;
  /**
   * The type of Action  which is a group to help facilitate aggregating for analytics (Saving Data, Download Data, Loading Data, View Changes)
   */
  ACTION_TYPE: string;
  /**
   * The Data Type that extends the required DLV data to provide additional insight into the context of the action generating the event.
   */
  EVENT_DATA: string;
  /**
   * Unique ID representing the Account ID plus a timestanp. Useful when 1 action generates multiple events for grouping these types of events.
   */
  EVENT_ID: string;
  /**
   * The general area of the application where these events are being sent from, such as the DLV.
   */
  EVENT_TYPE: string;
  /**
   * Validation Errors encounted when processing the data to send in the event.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  EVENT_VALIDATION_ERRORS: string[];
  /**
   * The Count of Adhoc Filters applied when a Report is Executed
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  REPORT_ADHOC_FILTER_COUNT?: number;
  /**
   * The Adhoc Filters applied when a Report is Executed
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  REPORT_ADHOC_FILTERS?: string[];
  /**
   * All the Filters applied when a Report is Executed
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  REPORT_ALL_FILTERS?: string[];
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  REPORT_ALL_FILTERS_COUNT?: number;
  /**
   * The Standard Report used as the Base Report when a user creates a custom report in the DLV
   */
  REPORT_BASE?: string;
  /**
   * The current number of Rows Displayed as a result of a Report Execution
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  REPORT_DISPLAY_ROWS?: number;
  /**
   * The name of the Report in the DLV if a Standard Report and 'User Defined' if a custom Report
   */
  REPORT_NAME: string;
  /**
   * Details pertaining to the Period the user is interacting with when historical data is made available to the User
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Max Value | 0 |
   */
  REPORT_PERIOD_LAG?: number;
  /**
   * The Count of Report or Saved Filters applied when a Report is Executed
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  REPORT_SAVED_FILTER_COUNT?: number;
  /**
   * The Saved Filters applied when a Report is Executed
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  REPORT_SAVED_FILTERS?: string[];
  /**
   * The Field or Column to used when a Sort is applied to data
   */
  REPORT_SORT_BY?: string;
  /**
   * The direction choosen when a Sort is applied
   */
  REPORT_SORT_ORDER?: string;
  /**
   * The total number of Children returned as a result of a Report Execution
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  REPORT_TOTAL_CHILDREN?: number;
  /**
   * The total number of Rows Returned as a result of a Report Execution
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  REPORT_TOTAL_ROWS?: number;
  /**
   * Indicates if a Report is a Standard or User Defined Report
   */
  REPORT_TYPE: string;
  /**
   * The Tab where the result of an Action changed to if a View Change occurred
   */
  TO_TAB?: string;
  /**
   * The View where the result of an Action changed to if a View Change occurred
   */
  TO_VIEW?: string;
  /**
   * How the user interacted with the Element that generated the Event (Mouse, Keyboard, Shortcut)
   */
  TRIGGER_ACTION: string;
  /**
   * The name of the Element that generated the Event
   */
  TRIGGER_ELEMENT: string;
  /**
   * Optional category that can be assigned to a group of Elements capable of triggering events to help facilite aggregating for analytics
   */
  TRIGGER_GROUP?: string;
  /**
   * Optional Tab when the Element triggering the Event is on a View with Tabs.
   */
  TRIGGER_TAB?: string;
  /**
   * The View where the Element is that triggered an Event
   */
  TRIGGER_VIEW: string;
  /**
   * Account ID of the logged in member generating the event.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   */
  USER_ACCOUNT_ID: number;
  USER_ACHIEVED_RANK: string;
  USER_AFFILIATION: string;
  USER_PAID_RANK: string;
}

export interface DlvReportSavedProperties {
  /**
   * The Action taken by the user by interacting with an Element which generates the event.
   */
  ACTION: string;
  /**
   * The type of Action  which is a group to help facilitate aggregating for analytics (Saving Data, Download Data, Loading Data, View Changes)
   */
  ACTION_TYPE: string;
  /**
   * The Data Type that extends the required DLV data to provide additional insight into the context of the action generating the event.
   */
  EVENT_DATA: string;
  /**
   * Unique ID representing the Account ID plus a timestanp. Useful when 1 action generates multiple events for grouping these types of events.
   */
  EVENT_ID: string;
  /**
   * The general area of the application where these events are being sent from, such as the DLV.
   */
  EVENT_TYPE: string;
  /**
   * Validation Errors encounted when processing the data to send in the event.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  EVENT_VALIDATION_ERRORS: string[];
  /**
   * The Standard Report used as the Base Report when a user creates a custom report in the DLV
   */
  REPORT_BASE?: string;
  /**
   * The name of the Report in the DLV if a Standard Report and 'User Defined' if a custom Report
   */
  REPORT_NAME: string;
  /**
   * The Count of Report or Saved Filters applied when a Report is Executed
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  REPORT_SAVED_FILTER_COUNT?: number;
  /**
   * The Saved Filters applied when a Report is Executed
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  REPORT_SAVED_FILTERS?: string[];
  /**
   * Indicates if a Report is a Standard or User Defined Report
   */
  REPORT_TYPE: string;
  /**
   * The Cadence in which a Scheduled Report should be Executed
   */
  SCHEDULE_CADENCE: string;
  /**
   * The Days of the Month in which a Scheduled Report should be Executed
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | number |
   */
  SCHEDULE_DAYS_OF_MONTH?: number[];
  /**
   * The Days of the Week in which a Scheduled Report should be Executed
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  SCHEDULE_DAYS_OF_WEEK?: string[];
  /**
   * The Period Lag to apply when a Scheduled Report should be Executed
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   * | Max Value | 0 |
   */
  SCHEDULE_PERIOD_LAG?: number;
  /**
   * The Time of Day in which a Scheduled Report should be Executed
   */
  SCHEDULE_TIME_OF_DAY?: string;
  /**
   * The Tab where the result of an Action changed to if a View Change occurred
   */
  TO_TAB?: string;
  /**
   * The View where the result of an Action changed to if a View Change occurred
   */
  TO_VIEW?: string;
  /**
   * How the user interacted with the Element that generated the Event (Mouse, Keyboard, Shortcut)
   */
  TRIGGER_ACTION: string;
  /**
   * The name of the Element that generated the Event
   */
  TRIGGER_ELEMENT: string;
  /**
   * Optional category that can be assigned to a group of Elements capable of triggering events to help facilite aggregating for analytics
   */
  TRIGGER_GROUP?: string;
  /**
   * Optional Tab when the Element triggering the Event is on a View with Tabs.
   */
  TRIGGER_TAB?: string;
  /**
   * The View where the Element is that triggered an Event
   */
  TRIGGER_VIEW: string;
  /**
   * Account ID of the logged in member generating the event.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   */
  USER_ACCOUNT_ID: number;
  USER_ACHIEVED_RANK: string;
  USER_AFFILIATION: string;
  USER_PAID_RANK: string;
}

export interface DlvReportSummaryProperties {
  /**
   * The Action taken by the user by interacting with an Element which generates the event.
   */
  ACTION: string;
  /**
   * The type of Action  which is a group to help facilitate aggregating for analytics (Saving Data, Download Data, Loading Data, View Changes)
   */
  ACTION_TYPE: string;
  /**
   * The Data Type that extends the required DLV data to provide additional insight into the context of the action generating the event.
   */
  EVENT_DATA: string;
  /**
   * Unique ID representing the Account ID plus a timestanp. Useful when 1 action generates multiple events for grouping these types of events.
   */
  EVENT_ID: string;
  /**
   * The general area of the application where these events are being sent from, such as the DLV.
   */
  EVENT_TYPE: string;
  /**
   * Validation Errors encounted when processing the data to send in the event.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  EVENT_VALIDATION_ERRORS: string[];
  /**
   * The Standard Report used as the Base Report when a user creates a custom report in the DLV
   */
  REPORT_BASE?: string;
  /**
   * The name of the Report in the DLV if a Standard Report and 'User Defined' if a custom Report
   */
  REPORT_NAME: string;
  /**
   * Indicates if a Report is a Standard or User Defined Report
   */
  REPORT_TYPE: string;
  /**
   * The Tab where the result of an Action changed to if a View Change occurred
   */
  TO_TAB?: string;
  /**
   * The View where the result of an Action changed to if a View Change occurred
   */
  TO_VIEW?: string;
  /**
   * How the user interacted with the Element that generated the Event (Mouse, Keyboard, Shortcut)
   */
  TRIGGER_ACTION: string;
  /**
   * The name of the Element that generated the Event
   */
  TRIGGER_ELEMENT: string;
  /**
   * Optional category that can be assigned to a group of Elements capable of triggering events to help facilite aggregating for analytics
   */
  TRIGGER_GROUP?: string;
  /**
   * Optional Tab when the Element triggering the Event is on a View with Tabs.
   */
  TRIGGER_TAB?: string;
  /**
   * The View where the Element is that triggered an Event
   */
  TRIGGER_VIEW: string;
  /**
   * Account ID of the logged in member generating the event.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   */
  USER_ACCOUNT_ID: number;
  USER_ACHIEVED_RANK: string;
  USER_AFFILIATION: string;
  USER_PAID_RANK: string;
}

export interface ErrorProperties {
  ERROR_CODE: string;
  ERROR_NAME: string;
}

export interface GlbFormProperties {
  /**
   * The Action taken by the user by interacting with an Element which generates the event.
   */
  ACTION: string;
  ERROR?: string;
  /**
   * Account ID of the logged in member generating the event.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   */
  USER_ACCOUNT_ID: number;
  USER_ACHIEVED_RANK: string;
  USER_AFFILIATION: string;
  USER_PAID_RANK: string;
}

export interface GlbPersonalMeetingProperties {
  /**
   * The Action taken by the user by interacting with an Element which generates the event.
   */
  ACTION: string;
  CREATED_DATE_UTC: string;
  EVENT_TIMING: string;
  MEETING_DATE: string;
  MEETING_TYPE: string;
  ROLE: string;
  /**
   * Account ID of the logged in member generating the event.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   */
  USER_ACCOUNT_ID: number;
  USER_ACHIEVED_RANK: string;
  USER_AFFILIATION: string;
  USER_PAID_RANK: string;
}

export interface GlbYlEventProperties {
  /**
   * The Action taken by the user by interacting with an Element which generates the event.
   */
  ACTION: string;
  CREATED_DATE_UTC: string;
  EVENT_TIMING: string;
  /**
   * Account ID of the logged in member generating the event.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   */
  USER_ACCOUNT_ID: number;
  USER_ACHIEVED_RANK: string;
  USER_AFFILIATION: string;
  USER_PAID_RANK: string;
  YL_EVENT_END_DATE: string;
  YL_EVENT_START_DATE: string;
  YL_EVENT_TYPE: string;
}

export interface PageViewProperties {
  /**
   * Last date of purchase including one-time, process now and/or loyalty.
   */
  CUSTOMER_STATUS?: string;
  /**
   * logged out means that amplitude id has logged in in the past
   *
   *
   *
   * no account would mean either there isn't an account associated with that id or they haven't logged in yet.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | LOGGED_IN, LOGGED_OUT |
   */
  LOGGED_IN_STATE: "LOGGED_IN" | "LOGGED_OUT";
  PAGE_PATH: string;
  PAGE_QUERY_STRING?: string;
  PAGE_TITLE: string;
  PAGE_URL: string;
  TIME_STAMP_LOCAL?: string;
}

export interface PromoViewProperties {
  /**
   * Last date of purchase including one-time, process now and/or loyalty.
   */
  CUSTOMER_STATUS?: string;
  /**
   * logged out means that amplitude id has logged in in the past
   *
   *
   *
   * no account would mean either there isn't an account associated with that id or they haven't logged in yet.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | LOGGED_IN, LOGGED_OUT |
   */
  LOGGED_IN_STATE: "LOGGED_IN" | "LOGGED_OUT";
  PAGE_PATH: string;
  PAGE_QUERY_STRING?: string;
  PAGE_TITLE: string;
  PAGE_URL: string;
  /**
   * Location of promotional content (such as home page, home page hero).
   */
  PROMO_LOCATION: string;
  /**
   * Name of promotional content. Not to be confused with PROMO_EVENT.
   */
  PROMO_NAME: string;
  /**
   * Should this start at 1?
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  PROMO_POSITION: number;
  TIME_STAMP_LOCAL?: string;
}

export interface ClickGroupProperties {
  /**
   * Location of the CLICK\_*NAME. For example, ADD_TO\_*CART can have a CLICK\_*LOCATION of QUICK\_*SEARCH or PRODUCT\_*CATEGORY\_*PAGE. See this doc for details: [CLICK_NAME & CLICK_LOCATION Screenshots.docx](https://younglivingeo-my.sharepoint.com/:w:/g/personal/cstevens_youngliving_com/EbtJBMuZDlhHgdpYEF0MG98BUHE7ZUZT6YsBOg3xB2UAIQ?e=59B1Ez)
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | QUICK_SEARCH, PRODUCT_CATEGORY_PAGE, CAROUSEL_MOST_POPULAR_PRODUCTS, CAROUSEL_SOURCED_FROM_THIS_FARM, CAROUSEL_YOU_MAY_ALSO_LIKE, CART_SIDEBAR, CART_PAGE, CHECKOUT_PAGE, TOP_NAV_BAR, AUTH_PAGE, PRODUCT_CATEGORY_DROPDOWN, PRODUCT_CATEGORY_LIST, CAROUSEL_FREQUENTLY_PURCHASED_WITH, PRODUCT_DETAIL_PAGE, LOYALTY_TEMPLATE |
   */
  CLICK_LOCATION:
    | "QUICK_SEARCH"
    | "PRODUCT_CATEGORY_PAGE"
    | "CAROUSEL_MOST_POPULAR_PRODUCTS"
    | "CAROUSEL_SOURCED_FROM_THIS_FARM"
    | "CAROUSEL_YOU_MAY_ALSO_LIKE"
    | "CART_SIDEBAR"
    | "CART_PAGE"
    | "CHECKOUT_PAGE"
    | "TOP_NAV_BAR"
    | "AUTH_PAGE"
    | "PRODUCT_CATEGORY_DROPDOWN"
    | "PRODUCT_CATEGORY_LIST"
    | "CAROUSEL_FREQUENTLY_PURCHASED_WITH"
    | "PRODUCT_DETAIL_PAGE"
    | "LOYALTY_TEMPLATE";
  /**
   * Grouping of click location. Some CLICK_NAMEs will have multiple CLICK_LOCATIONs (ie ADD_TO_CART).
   *
   * Screenshots of where each click lives:
   *
   * [CLICK_NAME & CLICK_LOCATION Screenshots.docx](https://younglivingeo-my.sharepoint.com/:w:/g/personal/cstevens_youngliving_com/EbtJBMuZDlhHgdpYEF0MG98BUHE7ZUZT6YsBOg3xB2UAIQ?e=59B1Ez)
   *
   *
   * !\[\](file:///C:/Users/cstevens/AppData/Local/Temp/msohtmlclip1/01/clip_image044.png)
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | ADD_TO_CART, ADD_TO_LOYALTY, PROMO, PRODUCT_LIST, FILTER_COMPLETE, FILTER_START, SORT, CONTINUE_SHOPPING, CHECKOUT_START, CHECKOUT_COMPLETE, QUANTITY_DELETE, CREATE_ACCOUNT_START, CREATE_ACCOUNT_COMPLETE, LOGIN_START, LOGIN_COMPLETE, ADD_TO_WISHLIST, CHECKOUT_CONTACT, CHECKOUT_SPONSOR, CHECKOUT_SHIPPING, CHECKOUT_PAYMENT_GENERAL, CHECKOUT_PAYMENT_VENMO, CHECKOUT_PAYMENT_PAYPAL, CHECKOUT_PAYMENT_PAYPAL_CREDIT, PAYPAL_BUY_NOW, VIEW_CART, VIEW_ALL, QUANTITY_DELETE_ALL, SAVE_PAYMENT, SAVE_TEMPLATE, REMIND_ME_LATER, ADD_BACKUP, DONT_SHOW |
   */
  CLICK_NAME:
    | "ADD_TO_CART"
    | "ADD_TO_LOYALTY"
    | "PROMO"
    | "PRODUCT_LIST"
    | "FILTER_COMPLETE"
    | "FILTER_START"
    | "SORT"
    | "CONTINUE_SHOPPING"
    | "CHECKOUT_START"
    | "CHECKOUT_COMPLETE"
    | "QUANTITY_DELETE"
    | "CREATE_ACCOUNT_START"
    | "CREATE_ACCOUNT_COMPLETE"
    | "LOGIN_START"
    | "LOGIN_COMPLETE"
    | "ADD_TO_WISHLIST"
    | "CHECKOUT_CONTACT"
    | "CHECKOUT_SPONSOR"
    | "CHECKOUT_SHIPPING"
    | "CHECKOUT_PAYMENT_GENERAL"
    | "CHECKOUT_PAYMENT_VENMO"
    | "CHECKOUT_PAYMENT_PAYPAL"
    | "CHECKOUT_PAYMENT_PAYPAL_CREDIT"
    | "PAYPAL_BUY_NOW"
    | "VIEW_CART"
    | "VIEW_ALL"
    | "QUANTITY_DELETE_ALL"
    | "SAVE_PAYMENT"
    | "SAVE_TEMPLATE"
    | "REMIND_ME_LATER"
    | "ADD_BACKUP"
    | "DONT_SHOW";
  /**
   * In the sort function, return what was selected.
   */
  SELECTED_SORT?: string;
}

export interface DlvDownlineMemberProperties {
  /**
   * Account ID of the Downline Member
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  VIEWING_ACCOUNT_ID: number;
  /**
   * Activation Date of the Downline Member
   */
  VIEWING_ACTIVATION_DATE?: string;
  /**
   * Autoship Active of the Downline Member
   */
  VIEWING_AUTOSHIP_ACTIVE?: boolean;
  /**
   * Autoship Day of the Month of the Downline Member
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  VIEWING_AUTOSHIP_DAY?: number;
  /**
   * Autoship Shipped of the Downline Member
   */
  VIEWING_AUTOSHIP_SHIPPED?: boolean;
  /**
   * Autoship Status of the Downline Member
   */
  VIEWING_AUTOSHIP_STATUS?: string;
  /**
   * Commission Qualified of the Downline Member
   */
  VIEWING_COMMISSION_QUALIFIED?: boolean;
  /**
   * Customer Type of the Downline Member
   */
  VIEWING_CUSTOMER_TYPE?: string;
  /**
   * Last Order Date of the Downline Member
   */
  VIEWING_LAST_ORDER_DATE?: string;
  /**
   * Max Rank of the Downline Member
   */
  VIEWING_MAX_RANK?: string;
  /**
   * Months Inactive of the Downline Member
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  VIEWING_MONTHS_INACTIVE?: number;
  /**
   * Months Without Order of the Downline Member
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  VIEWING_MONTHS_WITHOUT_ORDER?: number;
  /**
   * OGV of the Downline Member
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  VIEWING_OGV?: number;
  /**
   * Rank of the Downline Member
   */
  VIEWING_RANK?: string;
  /**
   * Signup Date of the Downline Member
   */
  VIEWING_SIGNUP_DATE?: string;
  /**
   * Total PV of the Downline Member
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  VIEWING_TOTAL_PV?: number;
}

export interface DlvReportDownloadProperties {
  /**
   * Added Columns in addition to the Select All States of Default and None
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  DOWNLOAD_ADDED_COLUMNS: string[];
  /**
   * The Default Columns presented to the user when first presented with the list of options.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  DOWNLOAD_DEFAULT_COLUMNS: string[];
  /**
   * Removed Columns from the Select All States of Default and All
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  DOWNLOAD_REMOVED_COLUMNS: string[];
  /**
   * The State of the Select All checkbox when the Download was initiated (Default, All, None)
   */
  DOWNLOAD_SELECT_ALL: string;
  /**
   * Final Columns selected by the user for Download
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  DOWNLOAD_SUBMITTED_COLUMNS: string[];
}

export interface DlvReportFilterProperties {
  /**
   * The name of the Column in which a Filter will be applied
   */
  REPORT_FILTER_COLUMN: string;
  /**
   * The name of the Operator in which a Filter will be applied
   */
  REPORT_FILTER_OPERATOR: string;
  /**
   * A Range of Filter Values when applicable
   */
  REPORT_FILTER_TIER?: string;
  /**
   * Indicates if the Filter being applied is part of a Saved Report or is an Adhoc Filter applied to a report
   */
  REPORT_FILTER_TYPE: string;
  /**
   * The entered Value in which a Filter will be applied
   */
  REPORT_FILTER_VALUE: string;
}

export interface DlvReportFiltersProperties {
  /**
   * The Count of Adhoc Filters applied when a Report is Executed
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  REPORT_ADHOC_FILTER_COUNT?: number;
  /**
   * The Adhoc Filters applied when a Report is Executed
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  REPORT_ADHOC_FILTERS?: string[];
  /**
   * All the Filters applied when a Report is Executed
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  REPORT_ALL_FILTERS?: string[];
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  REPORT_ALL_FILTERS_COUNT?: number;
  /**
   * The Count of Report or Saved Filters applied when a Report is Executed
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  REPORT_SAVED_FILTER_COUNT?: number;
  /**
   * The Saved Filters applied when a Report is Executed
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  REPORT_SAVED_FILTERS?: string[];
}

export interface DlvReportPeriodLagProperties {
  /**
   * Details pertaining to the Period the user is interacting with when historical data is made available to the User
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Max Value | 0 |
   */
  REPORT_PERIOD_LAG?: number;
}

export interface DlvReportResultsProperties {
  /**
   * The current number of Rows Displayed as a result of a Report Execution
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  REPORT_DISPLAY_ROWS?: number;
  /**
   * The total number of Children returned as a result of a Report Execution
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  REPORT_TOTAL_CHILDREN?: number;
  /**
   * The total number of Rows Returned as a result of a Report Execution
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  REPORT_TOTAL_ROWS?: number;
}

export interface DlvReportSavedFiltersProperties {
  /**
   * The Count of Report or Saved Filters applied when a Report is Executed
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  REPORT_SAVED_FILTER_COUNT?: number;
  /**
   * The Saved Filters applied when a Report is Executed
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  REPORT_SAVED_FILTERS?: string[];
}

export interface DlvReportScheduleProperties {
  /**
   * The Cadence in which a Scheduled Report should be Executed
   */
  SCHEDULE_CADENCE: string;
  /**
   * The Days of the Month in which a Scheduled Report should be Executed
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | number |
   */
  SCHEDULE_DAYS_OF_MONTH?: number[];
  /**
   * The Days of the Week in which a Scheduled Report should be Executed
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  SCHEDULE_DAYS_OF_WEEK?: string[];
  /**
   * The Period Lag to apply when a Scheduled Report should be Executed
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   * | Max Value | 0 |
   */
  SCHEDULE_PERIOD_LAG?: number;
  /**
   * The Time of Day in which a Scheduled Report should be Executed
   */
  SCHEDULE_TIME_OF_DAY?: string;
}

export interface DlvReportSortProperties {
  /**
   * The Field or Column to used when a Sort is applied to data
   */
  REPORT_SORT_BY?: string;
  /**
   * The direction choosen when a Sort is applied
   */
  REPORT_SORT_ORDER?: string;
}

export interface DlvReportSummaryProperties {
  /**
   * The Standard Report used as the Base Report when a user creates a custom report in the DLV
   */
  REPORT_BASE?: string;
  /**
   * The name of the Report in the DLV if a Standard Report and 'User Defined' if a custom Report
   */
  REPORT_NAME: string;
  /**
   * Indicates if a Report is a Standard or User Defined Report
   */
  REPORT_TYPE: string;
}

export interface DlvStandardEventPropertiesProperties {
  /**
   * The Action taken by the user by interacting with an Element which generates the event.
   */
  ACTION: string;
  /**
   * The type of Action  which is a group to help facilitate aggregating for analytics (Saving Data, Download Data, Loading Data, View Changes)
   */
  ACTION_TYPE: string;
  /**
   * The Data Type that extends the required DLV data to provide additional insight into the context of the action generating the event.
   */
  EVENT_DATA: string;
  /**
   * Unique ID representing the Account ID plus a timestanp. Useful when 1 action generates multiple events for grouping these types of events.
   */
  EVENT_ID: string;
  /**
   * The general area of the application where these events are being sent from, such as the DLV.
   */
  EVENT_TYPE: string;
  /**
   * Validation Errors encounted when processing the data to send in the event.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  EVENT_VALIDATION_ERRORS: string[];
  /**
   * The Tab where the result of an Action changed to if a View Change occurred
   */
  TO_TAB?: string;
  /**
   * The View where the result of an Action changed to if a View Change occurred
   */
  TO_VIEW?: string;
  /**
   * How the user interacted with the Element that generated the Event (Mouse, Keyboard, Shortcut)
   */
  TRIGGER_ACTION: string;
  /**
   * The name of the Element that generated the Event
   */
  TRIGGER_ELEMENT: string;
  /**
   * Optional category that can be assigned to a group of Elements capable of triggering events to help facilite aggregating for analytics
   */
  TRIGGER_GROUP?: string;
  /**
   * Optional Tab when the Element triggering the Event is on a View with Tabs.
   */
  TRIGGER_TAB?: string;
  /**
   * The View where the Element is that triggered an Event
   */
  TRIGGER_VIEW: string;
  /**
   * Account ID of the logged in member generating the event.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   */
  USER_ACCOUNT_ID: number;
  USER_ACHIEVED_RANK: string;
  USER_AFFILIATION: string;
  USER_PAID_RANK: string;
}

export interface ErrorGroupProperties {
  ERROR_CODE: string;
  ERROR_NAME: string;
}

export interface EveryBrowserEventGroupProperties {
  /**
   * Last date of purchase including one-time, process now and/or loyalty.
   */
  CUSTOMER_STATUS?: string;
  /**
   * logged out means that amplitude id has logged in in the past
   *
   *
   *
   * no account would mean either there isn't an account associated with that id or they haven't logged in yet.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | LOGGED_IN, LOGGED_OUT |
   */
  LOGGED_IN_STATE: "LOGGED_IN" | "LOGGED_OUT";
  PAGE_PATH: string;
  PAGE_QUERY_STRING?: string;
  PAGE_TITLE: string;
  PAGE_URL: string;
  TIME_STAMP_LOCAL?: string;
}

export interface OrderGroupProperties {
  /**
   * Specific to code entered at checkout. Sitewide/specific product sales will be seen in PROMO.
   */
  COUPON_CODE?: string;
  /**
   * Identifies the customer/member that placed the order. This is not to be confused with the user ID used by Amplitude. This ID should match to what is used in the data warehouse.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  CUST_ID?: number;
  /**
   * Identifies the order and should match order ID in the data warehouse. This is the BSI/Legacy order ID.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  ORDER_ID?: number;
  /**
   * Payment type of purchase (Amex, Visa, ACH, etc.)
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | American Express, Visa, ACH, Mastercard |
   */
  PAYMENT_METHOD?: "American Express" | "Visa" | "ACH" | "Mastercard";
  /**
   * Did the user purchase using Paypal quickpay option (not to be confused with using Paypal in regular checkout).
   */
  PAYPAL_BUY_NOW?: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | object |
   */
  PRODUCT_ARRAY?: {
    /**
     * To be used by the product array when one or multiple products' information is needed. For a given product in the array, flag whether this product has any restrictions.
     */
    HAS_RESTRICTIONS?: boolean;
    /**
     * To be used by the product array when one or multiple products' information is needed. For a given product in an array, flag whether the item was in the wishlist at the time of being called in the array.
     */
    IN_WISHLIST?: boolean;
    /**
     * To be used by the product array when one or multiple products' information is needed.
     */
    IS_RECOMMENDED_PRODUCT?: string;
    /**
     * To be used by the product array when one or multiple products' information is needed. For a given product in the array, this identifies the location of a list name. This is a subset of LIST_NAME. Use this when you have multiple carousels (for instance) that you need to identify.
     */
    LIST_LOCATION?: {
      [k: string]: any;
    };
    /**
     * To be used by the product array when one or multiple products' information is needed. For a given product in the array, what was the location that the product was added from? Including PDP and adding from quick search. \*\* May need to consider changing this property name to make it less confusing.
     */
    LIST_NAME?: "QUICK_SEARCH" | "PRODUCT_CAROUSEL" | "PRODUCT_CATEGORY_PAGE";
    /**
     * To be used by the product array when one or multiple products' information is needed. Given a product in the array, this identifies where on a list a product was added from. \*\* We need to design out how we'd like this to look?
     */
    LIST_POSITION?: number;
    /**
     * **To be used by the product array when one or multiple products' information is needed. For a given product in the array, this identifies whether or not the product was purchased with loyalty points during the checkout process.**
     */
    LOYALTY_POINTS_USED?: boolean;
    ORDER_SOURCE?: "AUTOSHIP" | "ONE_TIME";
    /**
     * To be used by the product array when multiple products' information is needed. This indicates SKU, which can include a letter for discounted SKUs.
     */
    PART_NUMBER?: string;
    /**
     * To be used by the product array when multiple products' information is needed. This is the SKU version without the letter indicating a discount. This will always be the full-price version of the SKU.
     */
    PART_NUMBER_MINUS_ALPHA?: number;
    /**
     * To be used by the product array when one or multiple products' information is needed. This should be reflected as the sale price, if the sale price exists at the moment of checkout. If there is not a price, keep this as null. \*\* Would this be better as a flag??
     */
    PRICE_ON_SALE?: number;
    /**
     * To be used by the product array when one or multiple products' information is needed. Retail price of a given product in the array. Only populate when retail price is given. (get feedback here from the group)
     */
    PRICE_RETAIL?: number;
    /**
     * To be used by the product array when one or multiple products' information is needed. This will be the wholesale price of a given product in the array. Only populate when the wholesale price is given.
     */
    PRICE_WHOLESALE?: number;
    /**
     * Will be used as part of the array when multiple products' information needs to be seen.
     */
    PRODUCT_NAME?: string;
    /**
     * To be used by the product array when multiple products' information is needed. This will show PV of a given product in the array.
     */
    PV?: number;
    /**
     * To be used by the product array when multiple products' information is needed. Quantity of given product in the array.
     */
    QUANTITY?: number;
    /**
     * To be used by the product array when one or multiple products' information is needed. For a given product in the array, identify the stock status when array was passed. Note: out of stock should not be a flag since a product won't be added or purchase if out of stock.
     */
    STOCK_STATUS?: "LOW_STOCK" | "IN_STOCK";
    /**
     * To be used by the product array when multiple products' information is needed. This will show the subtotal price of a given product in the array. If there is a wholesale or discounted price, it will be reflected in this number.
     */
    UNIT_PRICE?: number;
  }[];
  /**
   * Subtotal - total amount due before taxes and shipping.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  PRODUCT_SALES_AMOUNT_TOTAL?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  PV_TOTAL?: number;
}

export interface ProductGroupProperties {
  /**
   * 3-letter currency code. Will keep as a string for now since there are 156 different values.
   */
  CURRENCY_CODE?: string;
  /**
   * ??
   */
  HAS_RESTRICTIONS?: boolean;
  /**
   * Product added was currently in the wishlist.
   */
  IN_WISHLIST?: boolean;
  /**
   * Which list or carousel was the product added from?
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | QUICK_SEARCH_RESULTS, HOME_PAGE_POPULAR_PRODUCTS, PRODUCT_CATEGORY_PAGE, PRODUCT_DETAIL_YOU_MAY_ALSO_LIKE |
   */
  LIST_NAME?:
    | "QUICK_SEARCH_RESULTS"
    | "HOME_PAGE_POPULAR_PRODUCTS"
    | "PRODUCT_CATEGORY_PAGE"
    | "PRODUCT_DETAIL_YOU_MAY_ALSO_LIKE";
  /**
   * Where on the list was the product featured? Coincides with LIST_NAME. Start at 1.
   *
   * Home page 'most popular products', PDP 'you may also like', quick search and product category page all contain this feature.
   *
   * *Idea: Number corresponding to position depends on the feature.*
   *
   * **Home page 'most populat products' and PDP 'you may also like'**: Each view ("dot") correponds to a list position.
   *
   * **Product category page**: Each row and page correpond to a number. There are currently 6 rows to a page. A product listed in row 1, page 1 = LIST_POSITION 1. A product listed in row 6 of page 2 = LIST_POSITION 12.
   *
   * Quick search:
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   */
  LIST_POSITION?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | ONE_TIME, AUTOSHIP |
   */
  ORDER_SOURCE?: "ONE_TIME" | "AUTOSHIP";
  /**
   * Product SKU. If this contains a letter, it will indicate a discount.
   */
  PART_NUMBER?: string;
  /**
   * Product SKU removing any letters that indicate discount. This would show product SKU version that is full price.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  PART_NUMBER_MINUS_ALPHA?: number;
  PRODUCT_NAME?: string;
  /**
   * Indicates there was a sale on a product. Not to be confused with discounted products via PART_NUMBER or COUPON_CODE. Mark null if no promo existed.
   */
  PROMO_EVENT?: string;
  /**
   * PV of specific product.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  PV_AMOUNT?: number;
  /**
   * Quantity of product added in a given click (on add to carts).
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  QUANTITY?: number;
  /**
   * Indicates status of inventory when clicking add to cart. Note: 'out of stock' should not exist since it won't be possible to add to cart if item was out of stock.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | IN_STOCK, LOW_STOCK |
   */
  STOCK_STATUS?: "IN_STOCK" | "LOW_STOCK";
  /**
   * Subtotal price of product (before shipping and taxes). This should reflect any discounts, wholesale price. But not the price after applying COUPON_CODE.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  UNIT_PRICE?: number;
}

export interface PromoViewGroupProperties {
  /**
   * Location of promotional content (such as home page, home page hero).
   */
  PROMO_LOCATION: string;
  /**
   * Name of promotional content. Not to be confused with PROMO_EVENT.
   */
  PROMO_NAME: string;
  /**
   * Should this start at 1?
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  PROMO_POSITION: number;
}

export class Identify implements BaseEvent {
  event_type = amplitude.Types.SpecialEventType.IDENTIFY;

  constructor(
    public event_properties?: IdentifyProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class Click implements BaseEvent {
  event_type = 'CLICK';

  constructor(
    public event_properties: ClickProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DlvDownlineMember implements BaseEvent {
  event_type = 'DLV_DOWNLINE_MEMBER';

  constructor(
    public event_properties: DlvDownlineMemberProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DlvFilterDownloaded implements BaseEvent {
  event_type = 'DLV_FILTER_DOWNLOADED';

  constructor(
    public event_properties: DlvFilterDownloadedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DlvFilterExecuted implements BaseEvent {
  event_type = 'DLV_FILTER_EXECUTED';

  constructor(
    public event_properties: DlvFilterExecutedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DlvFilterSaved implements BaseEvent {
  event_type = 'DLV_FILTER_SAVED';

  constructor(
    public event_properties: DlvFilterSavedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DlvReportDownloaded implements BaseEvent {
  event_type = 'DLV_REPORT_DOWNLOADED';

  constructor(
    public event_properties: DlvReportDownloadedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DlvReportExecuted implements BaseEvent {
  event_type = 'DLV_REPORT_EXECUTED';

  constructor(
    public event_properties: DlvReportExecutedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DlvReportSaved implements BaseEvent {
  event_type = 'DLV_REPORT_SAVED';

  constructor(
    public event_properties: DlvReportSavedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DlvReportSummary implements BaseEvent {
  event_type = 'DLV_REPORT_SUMMARY';

  constructor(
    public event_properties: DlvReportSummaryProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class Error implements BaseEvent {
  event_type = 'ERROR';

  constructor(
    public event_properties: ErrorProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class GlbForm implements BaseEvent {
  event_type = 'GLB_FORM';

  constructor(
    public event_properties: GlbFormProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class GlbPersonalMeeting implements BaseEvent {
  event_type = 'GLB_PERSONAL_MEETING';

  constructor(
    public event_properties: GlbPersonalMeetingProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class GlbYlEvent implements BaseEvent {
  event_type = 'GLB_YL_EVENT';

  constructor(
    public event_properties: GlbYlEventProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PageView implements BaseEvent {
  event_type = 'PAGE_VIEW';

  constructor(
    public event_properties: PageViewProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PromoView implements BaseEvent {
  event_type = 'PROMO_VIEW';

  constructor(
    public event_properties: PromoViewProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export type PromiseResult<T> = { promise: Promise<T | void> };

const getVoidPromiseResult = () => ({ promise: Promise.resolve() });

// prettier-ignore
export class Ampli {
  private disabled: boolean = false;
  private amplitude?: BrowserClient;

  get client(): BrowserClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && 'apiKey' in options.client) {
      apiKey = options.client.apiKey;
    } else if ('environment' in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && 'instance' in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param properties The user properties.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    properties?: IdentifyProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options,  user_id: userId};
    }

    const amplitudeIdentify = new amplitude.Identify();
    const eventProperties = properties;
    if (eventProperties != null) {
      for (const [key, value] of Object.entries(eventProperties)) {
        amplitudeIdentify.set(key, value);
      }
    }
    return this.amplitude!.identify(
      amplitudeIdentify,
      options,
    );
  }

 /**
  * Flush the event.
  */
  flush() : PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.flush();
  }

  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(event: Event, options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.track(event, undefined, options);
  }

  /**
   * CLICK
   *
   * [View in Tracking Plan](https://data.amplitude.com/young-living/Development/events/main/latest/CLICK)
   *
   * This event tracks when a user clicks on a specific element within the platform. Dead clicks should not be counted as a CLICK event. Setting up clicks this way will allow us to create custom click events in Amplitude and choose from a menu of properties to use.
   *
   * Owner: Chrissy Stevens
   *
   * @param properties The event's properties (e.g. CLICK_LOCATION)
   * @param options Amplitude event options.
   */
  click(
    properties: ClickProperties,
    options?: EventOptions,
  ) {
    return this.track(new Click(properties), options);
  }

  /**
   * DLV_DOWNLINE_MEMBER
   *
   * [View in Tracking Plan](https://data.amplitude.com/young-living/Development/events/main/latest/DLV_DOWNLINE_MEMBER)
   *
   * Events with the Standard DLV & Downline Member properties
   *
   * @param properties The event's properties (e.g. ACTION)
   * @param options Amplitude event options.
   */
  dlvDownlineMember(
    properties: DlvDownlineMemberProperties,
    options?: EventOptions,
  ) {
    return this.track(new DlvDownlineMember(properties), options);
  }

  /**
   * DLV_FILTER_DOWNLOADED
   *
   * [View in Tracking Plan](https://data.amplitude.com/young-living/Development/events/main/latest/DLV_FILTER_DOWNLOADED)
   *
   * Events with the Standard DLV & Filter Downloaded properties
   *
   * @param properties The event's properties (e.g. ACTION)
   * @param options Amplitude event options.
   */
  dlvFilterDownloaded(
    properties: DlvFilterDownloadedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DlvFilterDownloaded(properties), options);
  }

  /**
   * DLV_FILTER_EXECUTED
   *
   * [View in Tracking Plan](https://data.amplitude.com/young-living/Development/events/main/latest/DLV_FILTER_EXECUTED)
   *
   * Events with the Standard DLV & Filter Executed properties
   *
   * @param properties The event's properties (e.g. ACTION)
   * @param options Amplitude event options.
   */
  dlvFilterExecuted(
    properties: DlvFilterExecutedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DlvFilterExecuted(properties), options);
  }

  /**
   * DLV_FILTER_SAVED
   *
   * [View in Tracking Plan](https://data.amplitude.com/young-living/Development/events/main/latest/DLV_FILTER_SAVED)
   *
   * Events with the Standard DLV & Filter Saved properties
   *
   * @param properties The event's properties (e.g. ACTION)
   * @param options Amplitude event options.
   */
  dlvFilterSaved(
    properties: DlvFilterSavedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DlvFilterSaved(properties), options);
  }

  /**
   * DLV_REPORT_DOWNLOADED
   *
   * [View in Tracking Plan](https://data.amplitude.com/young-living/Development/events/main/latest/DLV_REPORT_DOWNLOADED)
   *
   * Events with the Standard DLV & Report Downloaded properties
   *
   * @param properties The event's properties (e.g. ACTION)
   * @param options Amplitude event options.
   */
  dlvReportDownloaded(
    properties: DlvReportDownloadedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DlvReportDownloaded(properties), options);
  }

  /**
   * DLV_REPORT_EXECUTED
   *
   * [View in Tracking Plan](https://data.amplitude.com/young-living/Development/events/main/latest/DLV_REPORT_EXECUTED)
   *
   * Events with the Standard DLV & Report Executed properties
   *
   * @param properties The event's properties (e.g. ACTION)
   * @param options Amplitude event options.
   */
  dlvReportExecuted(
    properties: DlvReportExecutedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DlvReportExecuted(properties), options);
  }

  /**
   * DLV_REPORT_SAVED
   *
   * [View in Tracking Plan](https://data.amplitude.com/young-living/Development/events/main/latest/DLV_REPORT_SAVED)
   *
   * Events with the Standard DLV & Report Saved properties
   *
   * @param properties The event's properties (e.g. ACTION)
   * @param options Amplitude event options.
   */
  dlvReportSaved(
    properties: DlvReportSavedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DlvReportSaved(properties), options);
  }

  /**
   * DLV_REPORT_SUMMARY
   *
   * [View in Tracking Plan](https://data.amplitude.com/young-living/Development/events/main/latest/DLV_REPORT_SUMMARY)
   *
   * Events with the Standard DLV & Report Summary properties
   *
   * @param properties The event's properties (e.g. ACTION)
   * @param options Amplitude event options.
   */
  dlvReportSummary(
    properties: DlvReportSummaryProperties,
    options?: EventOptions,
  ) {
    return this.track(new DlvReportSummary(properties), options);
  }

  /**
   * ERROR
   *
   * [View in Tracking Plan](https://data.amplitude.com/young-living/Development/events/main/latest/ERROR)
   *
   * Event triggered when an error occurs within the system.
   *
   * Owner: Chrissy Stevens
   *
   * @param properties The event's properties (e.g. ERROR_CODE)
   * @param options Amplitude event options.
   */
  error(
    properties: ErrorProperties,
    options?: EventOptions,
  ) {
    return this.track(new Error(properties), options);
  }

  /**
   * GLB_FORM
   *
   * [View in Tracking Plan](https://data.amplitude.com/young-living/Development/events/main/latest/GLB_FORM)
   *
   * Generation Leadership Bonus form failing to load event
   *
   * @param properties The event's properties (e.g. ACTION)
   * @param options Amplitude event options.
   */
  glbForm(
    properties: GlbFormProperties,
    options?: EventOptions,
  ) {
    return this.track(new GlbForm(properties), options);
  }

  /**
   * GLB_PERSONAL_MEETING
   *
   * [View in Tracking Plan](https://data.amplitude.com/young-living/Development/events/main/latest/GLB_PERSONAL_MEETING)
   *
   * **Event when a Personal Meeting is submitted on the GLB form**
   *
   * @param properties The event's properties (e.g. ACTION)
   * @param options Amplitude event options.
   */
  glbPersonalMeeting(
    properties: GlbPersonalMeetingProperties,
    options?: EventOptions,
  ) {
    return this.track(new GlbPersonalMeeting(properties), options);
  }

  /**
   * GLB_YL_EVENT
   *
   * [View in Tracking Plan](https://data.amplitude.com/young-living/Development/events/main/latest/GLB_YL_EVENT)
   *
   * **Event when a YL Event is submitted on the GLB form**
   *
   * @param properties The event's properties (e.g. ACTION)
   * @param options Amplitude event options.
   */
  glbYlEvent(
    properties: GlbYlEventProperties,
    options?: EventOptions,
  ) {
    return this.track(new GlbYlEvent(properties), options);
  }

  /**
   * PAGE_VIEW
   *
   * [View in Tracking Plan](https://data.amplitude.com/young-living/Development/events/main/latest/PAGE_VIEW)
   *
   * This event tracks when a user views a specific page on the website.
   *
   * Owner: Chrissy Stevens
   *
   * @param properties The event's properties (e.g. CUSTOMER_STATUS)
   * @param options Amplitude event options.
   */
  pageView(
    properties: PageViewProperties,
    options?: EventOptions,
  ) {
    return this.track(new PageView(properties), options);
  }

  /**
   * PROMO_VIEW
   *
   * [View in Tracking Plan](https://data.amplitude.com/young-living/Development/events/main/latest/PROMO_VIEW)
   *
   * Event to track when a user views a promotional banner.
   *
   * Owner: Chrissy Stevens
   *
   * @param properties The event's properties (e.g. CUSTOMER_STATUS)
   * @param options Amplitude event options.
   */
  promoView(
    properties: PromoViewProperties,
    options?: EventOptions,
  ) {
    return this.track(new PromoView(properties), options);
  }
}

export const ampli = new Ampli();

// BASE TYPES
type BrowserOptions = amplitude.Types.BrowserOptions;

export type BrowserClient = amplitude.Types.BrowserClient;
export type BaseEvent = amplitude.Types.BaseEvent;
export type IdentifyEvent = amplitude.Types.IdentifyEvent;
export type GroupEvent = amplitude.Types.GroupIdentifyEvent;
export type Event = amplitude.Types.Event;
export type EventOptions = amplitude.Types.EventOptions;
export type Result = amplitude.Types.Result;
